import { PropsWithChildren } from "react";
import styled from "styled-components";

const StyledLabel = styled.label`
  color: var(--color-label);
`;

export interface ILabelProps {
  htmlFor: string;
  className?: string;
}

export function Label({
  htmlFor,
  children,
  className,
}: PropsWithChildren<ILabelProps>): JSX.Element {
  return (
    <StyledLabel htmlFor={htmlFor} className={className}>
      {children}
    </StyledLabel>
  );
}
